// Booking panel on the tour page: date/price calendar, passengers, summary and mobile dock.
export default {
  bookingUi: {
    perAdult: 'per adult',
    secureNote: 'Pay the deposit by Pix (QR code or copy and paste). You get your voucher right after confirmation.',
    calendar: {
      prevMonth: 'Previous month',
      nextMonth: 'Next month',
      today: 'Today',
      selected: 'Selected',
      unavailable: 'Unavailable',
      lowest: 'Lowest price this month',
      legend: 'Calendar legend',
      noDate: 'No date chosen yet',
      noDateHint: 'Tap a day to see its price.',
      pricePerAdult: '{{price}} per adult',
    },
    passengers: {
      title: 'Passengers',
      adults: 'Adults',
      children: 'Children',
      babies: 'Babies',
      adultsAge: '10 years and over',
      childrenAge: '5 to 9 years',
      babiesAge: '0 to 4 years',
      each: '{{price}} each',
    },
    summary: {
      title: 'Booking summary',
      adultsLine_one: '{{count}} adult × {{price}}',
      adultsLine_other: '{{count}} adults × {{price}}',
      childrenLine_one: '{{count}} child × {{price}}',
      childrenLine_other: '{{count}} children × {{price}}',
      babiesLine_one: '{{count}} baby',
      babiesLine_other: '{{count}} babies',
      depositNow: 'Deposit now · Pix',
      fullNow: 'Full payment now · Pix',
    },
    errors: {
      closed: 'There are no departures on this date. Please pick another day.',
    },
    dock: {
      label: 'Quick booking',
      from: 'From',
      chooseDate: 'Choose date',
    },
  },
};
